module.exports = __webpack_public_path__ + "img/skull_15.51c5169b.png";